import React from 'react';
import { Icon, palette } from '@m12s/component-library';
import { search, arrowLeft } from 'lib/icons';
import styled from 'styled-components';
import { getSelectWorkOrderOpOptions } from 'lib/selectors/getSelectWorkOrderOp';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { getProductionScheduleEnabled } from 'lib/selectors/getProductionScheduleEnabled';

const SearchHeaderContainer = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 3rem auto;
  gap: 1rem;
  align-items: center;
  grid-template-columns: 3rem 1fr 20rem;
`;

const StandardHeaderContainer = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 3rem 1fr auto;
  gap: 1rem;
  align-items: center;
`;

const StyledButton = styled.div`
  background: #ffffff;
  border: 2px solid #e2e8f0;
  border-radius: 2px;
  width: 100%;

  height: 2.5rem;
  width: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;

  :hover {
    cursor: pointer;
    background-color: ${palette.Grey100};
  }
`;

const TitleText = styled.span`
  font-size: 1.25rem;
  font-weight: 600;
  letter-spacing: 0.1px;
  color: ${palette.Grey700};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Header = ({ SwitchToggle, SearchInput, changeSearchMode, title }) => {
  const { isSearchMode } = useSelector(getSelectWorkOrderOpOptions);
  const productionScheduleEnabled = useSelector(getProductionScheduleEnabled);

  const HeaderContainer = isSearchMode
    ? SearchHeaderContainer
    : StandardHeaderContainer;

  return (
    <HeaderContainer isSearchMode={isSearchMode}>
      <StyledButton onClick={changeSearchMode}>
        {isSearchMode ? (
          <Icon icon={arrowLeft} size="1rem" color={palette.Grey600} />
        ) : (
          <Icon icon={search} size="1rem" color={palette.Grey600} />
        )}
      </StyledButton>
      {isSearchMode ? (
        SearchInput
      ) : (
        <div style={{ minWidth: 0 }}>
          {title && <TitleText>{title}</TitleText>}
        </div>
      )}
      {(productionScheduleEnabled || isSearchMode) && SwitchToggle}
    </HeaderContainer>
  );
};

Header.propTypes = {
  SwitchToggle: PropTypes.node.isRequired,
  SearchInput: PropTypes.node.isRequired,
  changeSearchMode: PropTypes.func.isRequired,
  title: PropTypes.string,
};

export default Header;
